import Vue from 'vue'
import Events from '../events'
import router from '../router'
import auth from '../auth'
import { noData } from './../locale/vuetify'
import moment from 'moment'
import RegisterExternalExaminer from './RegisterExternalExaminer.vue'
import VueSweetAlert from 'vue-sweetalert'

export default {
    name: 'ExamMixin',
    props: {
        id: {
            type: [Number, String],
            default: 0
        }
    },
    components: {
        RegisterExternalExaminer
    },
    data() {
        return {
            exam: {
                id: 0,
                course: (typeof auth.user.courses !== 'undefined' && auth.user.courses.length > 0 ? auth.user.courses[0].toString() : ''),
                student: [''],
                studentName: [''],
                type: '',
                topic: '',
                title: '',
                release_date:'',
                date: '',
                hour: '',
                semesters: '',
                place: 'Sala 01 do Bloco A',
                vacancies: 25,
                chair: '',
                advisor: '',
                examiners: ['', ''],
                substitutes: [],
                notes: '',
                finalScore: 0,
                minutes: null,
                situation: null,
                obs_of_situation: null,
                externalNote: 0
            },
            menuReleaseDate: '',
            menuDate: '',
            menuTime: '',
            types: [],
            teachers: [],
            courses: [],
            students: [],
            searchStudentVal: null,
            searchStudentMeta: {
                'minChars': 4,
                'timeLapse': 1000
            },
            studentLoading: false,
            submited: false,
            submitErrors: false,
            fatalError: false,
            edit: false,
            pendingRequests: [],
            studentChecked: false,
            readonly: false,
            noDataText: noData,
            chairIsExaminer: false,
            externalExaminerDialog: false,
            isFinished: false
        }
    },
    computed: {
        teachersById: function () {
            let teachers = []
            for (let teacher of this.teachers) {
                teachers[teacher['id']] = teacher['name']
            }
            return teachers
        },
        allTeachers: function () {
            if (!this.exam || !this.teachersById || this.teachersById.length == 0) {
                return []
            }
            let teachers = []
            if (this.exam.chair) teachers.push([this.exam.chair, 'presidente'])
            for (let examiner of this.exam.examiners) {
                if (examiner) teachers.push([examiner, 'examinador'])
            }
            for (let substitute of this.exam.substitutes) {
                if (substitute) teachers.push([substitute, 'examinador suplente'])
            }
            return teachers.map(value => {
                return { id: value[0], name: this.teachersById[value[0]], role: value[1] }
            })
        },
        userCourses: function () {
            if (auth.user.roles.includes('admin')) return this.courses
            let courses = []
            for (let course of this.courses) {
                if (auth.user.courses.includes(course.id) || course.id == this.exam.course) {
                    courses.push(course)
                }
            }
            return courses
        },
        courseTypes: function () {
            let types = []
            for (let type of this.types) {
                // if (type.courses.includes(this.exam.course) || type == this.exam.type) {
                    types.push(type)
                // }
            }
            return types
        },
        formattedDate: function () {
            return this.formatDate(this.exam.date)
        },
        formattedReleaseDate: function () {
            return this.formatDate(this.exam.release_date)
        }
    },
    methods: {
        formatDate: function (date) {
            return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
        submit: function () {
            this.$http.put('exams', this.exam).then(response => {
                if (typeof response.body.id !== 'undefined' && response.body.id > 0) {
                    this.submitErrors = false
                    this.submited = true
                    this.exam.id = response.body.id
                    this.isFinished = this.exam.finalScore > 0
                    this.$store.commit('setLastModifiedExam', this.exam)
                } else {
                    this.handleBadResponse(response)
                }
            }, response => {
                console.error('Erro ao submeter os dados para o servidor.')
                this.handleBadResponse(response)
            });
        },
        handleBadResponse: function (response) {
            this.submitErrors = []
            console.log(response.body.errors)
            if (typeof response.body.errors !== 'undefined') {
                for (let key in response.body.errors) this.submitErrors.push(response.body.errors[key])
            } else {
                this.submitErrors.push('Erro não especificado no servidor.')
            }
        },
        reset: function () {

            var keep = {
                courses: this.courses,
                teachers: this.teachers,
                types: this.types
            }
            Object.assign(this.$data, this.$options.data.apply(this))
            this.init()
            this.$validator.reset()
            this.courses = keep.courses
            this.teachers = keep.teachers
            this.types = keep.types
        },
        init: function () {

            let _idParam = this.$route.params.id;
            this.id = (_idParam != undefined) ? _idParam : 0;

            if (parseInt(this.id) > 0) {
                // Edition mode
                this.$http.post('exams', { id: this.id }).then(response => {
                    if (response.body.length > 0) {
                        this.edit = true
                        this.studentChecked = true
                        let returnedExam = response.body[0]
                        this.updateChairIsExaminer(returnedExam)
                        this.exam = returnedExam
                        this.readonly = true
                        if (typeof this.exam.perms !== 'undefined') {
                            this.readonly = (this.exam.perms['edit'] == false)
                        }
                        this.isFinished = this.exam.finalScore > 0
                    } else {
                        this.fatalError = true
                        console.error('Erro ao buscar informações da banca.')
                        console.debug(response)
                    }
                }, response => {
                    this.fatalError = true
                    console.error('Erro ao buscar informações da banca.')
                    console.debug(response)
                });
            } else {
                // New mode (initialize data)
                this.exam.release_date = Vue.moment().format('YYYY-MM-DD')
                this.exam.date = Vue.moment().format('YYYY-MM-DD')
                this.exam.hour = Vue.moment().format('HH:mm')
                let lastExam = this.$store.state.lastModifiedExam
                if (lastExam && typeof lastExam !== 'undefined' && lastExam.course) {
                    this.exam.course = lastExam.course
                    this.exam.type = lastExam.type
                    this.exam.release_date = lastExam.release_date
                    this.exam.date = lastExam.date
                    this.exam.place = lastExam.place
                }
            }
        },
        // Checks whether the input course and student was already inserted in the database
        // if yes, then previous data is loaded by redirecting the user to edit mode
        checkStudent: function () {

            if (!this.studentChecked && this.exam.course && this.exam.student && this.exam.type) {
                this.$http.post('exams', { student: this.exam.student }).then(response => {

                    if (response.data.length > 0) {
                        let selectedExam = false
                        for (let key in response.data) {
                            let exam = response.data[key]
                            if (exam.course == this.exam.course && exam.type == this.exam.type) {
                                selectedExam = exam
                            }
                        }
                        if (selectedExam != false) {
                            let name = 'examDetail'
                            if (router.history.current.path == '/bancas/planejar') name = 'examPlan'
                            router.push({ 'name': name, 'params': { id: selectedExam.id }})
                        } else {
                            this.studentChecked = true
                        }
                    } else {
                        if (response.status == 200) {
                            this.studentChecked = true
                        } else {
                            this.fatalError = true
                            console.error('Erro ao buscar informações das bancas do estudante.')
                            console.debug(response)
                        }
                    }

                }, response => {
                    this.fatalError = true
                    console.error('Erro ao buscar informações das bancas do estudante.')
                    console.debug(response)
                });
            }
        },
        searchStudent: function(val) {
            this.studentLoading = true
            let params = {
                'name': val,
                'course': this.exam.course,
                'year': this.exam.semesters.substring(0,4),
                'semester': this.exam.semesters.substring(4,5)
            }
            this.$http['post']('students', params).then(response => {
                let students = response.body
                for (let key in students) {
                    let aux = students[key].name_and_id = '[' + students[key].id + '] ' + students[key].name
                    this.students.push(aux);
                }
                //this.students.push(students)
                this.studentLoading = false
            }, response => {
                console.log(response);
                this.studentLoading = false
            })
        },
        checkChairIsExaminer: function(examinersChanged) {
            let chair = this.exam.chair,
                chairIsNowExaminer = this.exam.examiners.includes(chair)
            if (!chair) return false
            if (!examinersChanged) {
                if (this.chairIsExaminer && !chairIsNowExaminer) this.exam.examiners.push(chair)
                if (!this.chairIsExaminer && chairIsNowExaminer) this.exam.examiners.remove(chair)
            }
            this.updateChairIsExaminer(this.exam)
        },
        updateChairIsExaminer: function(exam) {
            this.chairIsExaminer = exam.examiners.includes(exam.chair)
        },
        externalExaminerRegistered: function(examiner) {
            if (!examiner || !examiner.id) return false
            if (!this.teachersById.includes(examiner.id)) {
                this.teachers.push(examiner)
            }
            if (!this.exam.examiners.includes(examiner.id)) {
                let pos = -1
                for (let key in this.exam.examiners) {
                    if (this.exam.examiners[key] == '') {
                        pos = key
                        break
                    }
                }
                if (pos == -1) {
                    this.exam.examiners.push(examiner.id)
                } else {
                    this.exam.examiners[pos] = examiner.id
                }
            }
        }
    },
    created: function () {

        this.$store.state.userLoged = auth.user;

        // Init form data (async)
        setTimeout(() => {
            this.init()
        }, 1000);


        // Load courses
        this.$http.get('courses').then(response => {
            this.courses = response.body
        }, response => {
            console.error('Erro ao buscar relação de cursos.')
            console.debug(response)
        });

        // Load teachers
        this.$http.post('teachers', { limit: 99999 }).then(response => {
            this.teachers = response.body
        }, response => {
            console.error('Erro ao buscar relação de professores.')
            console.debug(response)
        });

        // Load types
        this.$http.post('examTypes', { limit: 99999 }).then(response => {
            this.types = response.data.types
        }, response => {
            console.error('Erro ao buscar relação de tipos de banca.')
            console.debug(response)
        });
    },
    watch: {
        '$route': function (to, from) {
            this.reset()
        },
        'exam.course': function (newValue) {

            this.checkStudent()
            if (!this.exam.id && !this.exam.chair)  {
                // Até 12/2017, apenas no curso de Arq&Urb (1028) o presidente não era examinador também na banca
                this.chairIsExaminer = this.exam.course == '1028' ? false : true
            }
        },
        'exam.student': function (newValue) {
            this.studentName = ''
            if (this.students && this.exam.student) {
                for (let key in this.students) {
                    if (this.students[key].id == this.exam.student) {
                        this.exam.studentName = this.students[key].name
                        break
                    }
                }
            }
            this.checkStudent()
        },
        'exam.type': function (newValue) {
            this.checkStudent()
        },
        'chairIsExaminer': function (newValue) {
            this.checkChairIsExaminer(false)
         },
        'exam.chair': function (newValue) {
            this.checkChairIsExaminer(false)
        },
        'exam.examiners': function (newValue) {
            this.checkChairIsExaminer(true)
        },
        searchStudentVal(val) {
            let time = Date.now()
            if (this.searchStudentMeta['lastTime']) {
                let lastTime = this.searchStudentMeta['lastTime'],
                    lastString = this.searchStudentMeta['lastString'],
                    minChars = this.searchStudentMeta['minChars'],
                    timeLapse = this.searchStudentMeta['timeLapse']
                if (time < lastTime + timeLapse) return false;
                if (typeof val !== 'string') return false;
                if (val.length < minChars) return false;
                if (val == lastTime) return false;
            } else {
                this.searchStudentMeta = {}
            }
            val && this.exam.course && this.searchStudent(val)
            this.searchStudentMeta['lastTime'] = time
            this.searchStudentMeta['lastString'] = val
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ExamMixin.js